// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__QEZgR","buttons":"PendingPaymentAlert_buttons__1sxt3"};